import template from './pitchBadge.html';

const pitchBadge = {
  template,
  bindings: {
    status: '@',
    label: '@'
  }
};

export default function (ngModule) {
  ngModule.component('pitchBadge', pitchBadge);
}
